import { combineReducers } from "redux";

import reduceBimtrack, { BimtrackStore } from "./reduce_bimtrack";
import reduceCommentThreads, { CommentThreadsStore } from "./reduce_comment_threads";
import reduceFiles, { FilesStore } from "./reduce_files";
import reduceFloors, { FloorsStore } from "./reduce_floors";
import reduceFloorBuiltElementCounts, { FloorBuiltElementCountsStore } from "./reduce_floor_built_element_counts";
import reduceFloorTradeBuiltElementCounts, { FloorTradeBuiltElementCountsStore } from "./reduce_floor_trade_built_element_counts";
import reduceFloorTradeDeviationMagnitudes, { FloorTradeDeviationMagnitudesStore } from "./reduce_floor_trade_deviation_magnitudes";
import reduceGroupMembers, { GroupMembersStore } from "./reduce_group_members";
import reduceGroups, { GroupsStore } from "./reduce_groups";
import reduceInspectReports, { InspectReportsStore } from "./reduce_inspect_reports";
import reduceIntegrationCredentials, { IntegrationCredentialsStore } from "./reduce_integration_credentials";
import reduceIntegrationIssues, { IntegrationIssuesStore } from "./reduce_integration_issues";
import reduceIntegrationProjects, { IntegrationProjectStore } from "./reduce_integration_projects";
import reduceMasterformats, { MasterformatsStore } from "./reduce_masterformats";
import reduceMasterFormatsWithUniformat, { MasterFormatWithUniformatStore } from "./reduce_masterFormat_with_uniformat";
import reduceMasterformatTree, { MasterformatTreeStore } from "./reduce_masterformat_classes";
import reduceOrganizations, { OrganizationsStore } from "./reduce_organizations";
import reduceOrganizationUsers, { OrganizationUserStore } from "./reduce_organization_users";
import reducePermissions, { PermissionsStore } from "./reduce_permissions";
import reducePhotoAreas, { PhotoAreasStore } from "./reduce_photo_areas";
import reducePhotoLocations, { PhotoLocationsStore } from "./reduce_photo_locations";
import reducePhotoSessions, { PhotoSessionsStore } from "./reduce_photo_sessions";
import reducePlannedBuildingElements, { PlannedBuildingElementsStore } from "./reduce_planned_building_elements";
import reduceElementDetails, { ElementDetailsStore } from "./reduce_element_details";
import reduceProjectAreas, { ProjectAreasStore } from "./reduce_project_areas";
import reduceProjectAreaWorkPackages, { ProjectAreaWorkPackagesStore } from "./reduce_project_area_work_packages";
import reduceProjects, { ProjectsStore } from "./reduce_projects";
import reduceProjectSummary, { ProjectSummaryStore } from "./reduce_project_summary";
import reduceProjectDeviationSummaries, { ProjectDeviationSummariesStore } from "./reduce_project_deviation_summaries";
import reduceProjectProgressSummaries, { ProjectProgressSummariesStore } from "./reduce_project_progress_summaries";
import reduceRecipes, { RecipesStore } from "./reduce_recipes";
import reduceScanDatasets, { ScanDatasetsStore } from "./reduce_scan_datasets";
import reduceTeamMembers, { TeamMembersStore } from "./reduce_team_members";
import reduceTradeCosts, { TradeCostsStore } from "./reduce_trade_costs";
import reduceTrades, { TradesStore } from "./reduce_trades";
import reduceWorkPackages, { WorkPackagesStore } from "./reduce_work_packages";
import { reduceOrganizationMembers, OrganizationMemberStore } from "./reduce_organization_members";

export interface DomainStore {
  commentThreads: CommentThreadsStore;
  organizations: OrganizationsStore;
  projects: ProjectsStore;
  floors: FloorsStore;
  integrationCredentials: IntegrationCredentialsStore;
  integrationProjects: IntegrationProjectStore;
  integrationIssues: IntegrationIssuesStore;
  scanDatasets: ScanDatasetsStore;
  photoAreas: PhotoAreasStore;
  photoSessions: PhotoSessionsStore;
  photoLocations: PhotoLocationsStore;
  plannedBuildingElements: PlannedBuildingElementsStore;
  elementDetails: ElementDetailsStore;
  files: FilesStore;
  masterformats: MasterformatsStore;
  bimtrack: BimtrackStore;
  masterformatTree: MasterformatTreeStore;
  permissions: PermissionsStore
  projectSummary: ProjectSummaryStore;
  projectDeviationSummaries: ProjectDeviationSummariesStore;
  floorTradeDeviationMagnitudes: FloorTradeDeviationMagnitudesStore;
  floorBuiltElementCounts: FloorBuiltElementCountsStore;
  floorTradeBuiltElementCounts: FloorTradeBuiltElementCountsStore;
  projectProgressSummaries: ProjectProgressSummariesStore;
  projectAreas: ProjectAreasStore;
  projectAreaWorkPackages: ProjectAreaWorkPackagesStore;
  organizationUsers: OrganizationUserStore;
  groups: GroupsStore;
  groupMembers: GroupMembersStore;
  recipes: RecipesStore;
  inspectReports: InspectReportsStore;
  teamMembers: TeamMembersStore;
  trades: TradesStore;
  tradeCosts: TradeCostsStore;
  workPackages: WorkPackagesStore;
  masterformatsWithUniformat: MasterFormatWithUniformatStore;
  organizationMembers: OrganizationMemberStore;
}

const domainReducer = combineReducers({
  commentThreads: reduceCommentThreads,
  organizations: reduceOrganizations,
  projects: reduceProjects,
  floors: reduceFloors,
  integrationCredentials: reduceIntegrationCredentials,
  integrationProjects: reduceIntegrationProjects,
  integrationIssues: reduceIntegrationIssues,
  scanDatasets: reduceScanDatasets,
  photoAreas: reducePhotoAreas,
  photoSessions: reducePhotoSessions,
  photoLocations: reducePhotoLocations,
  plannedBuildingElements: reducePlannedBuildingElements,
  elementDetails: reduceElementDetails,
  files: reduceFiles,
  masterformats: reduceMasterformats,
  bimtrack: reduceBimtrack,
  masterformatTree: reduceMasterformatTree,
  permissions: reducePermissions,
  projectSummary: reduceProjectSummary,
  projectDeviationSummaries: reduceProjectDeviationSummaries,
  floorTradeDeviationMagnitudes: reduceFloorTradeDeviationMagnitudes,
  floorBuiltElementCounts: reduceFloorBuiltElementCounts,
  floorTradeBuiltElementCounts: reduceFloorTradeBuiltElementCounts,
  projectProgressSummaries: reduceProjectProgressSummaries,
  projectAreas: reduceProjectAreas,
  projectAreaWorkPackages: reduceProjectAreaWorkPackages,
  organizationUsers: reduceOrganizationUsers,
  groups: reduceGroups,
  groupMembers: reduceGroupMembers,
  recipes: reduceRecipes,
  inspectReports: reduceInspectReports,
  teamMembers: reduceTeamMembers,
  trades: reduceTrades,
  tradeCosts: reduceTradeCosts,
  workPackages: reduceWorkPackages,
  masterformatsWithUniformat: reduceMasterFormatsWithUniformat,
  organizationMembers: reduceOrganizationMembers,
});

export default domainReducer;
